/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions, Checkbox } from '@mui/material';

import { Box } from '@mui/system';

import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";

import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';

import { useSnackbar } from 'notistack';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function ModalComponent(props) {

    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
        

    }, [])

    return (
        <>
            <Dialog className="dialog-box"
                fullScreen
                open={props.showModalState}
                onClose={props.handleModalClose}
                TransitionComponent={Transition}
            >
                <Box>
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666', width: '100%', position: 'fixed', top: '0px' }}>
                        <Toolbar sx={{ bgcolor: '#fff' }}>
                            {props.modalHeaderRightBtn && <Button className={`${props?.headerRightBtnClass} f-11`} sx={props?.headerRightBtnStyle} onClick={props.headerRightBtnFunction}>
                                {props.headerRightBtnTitle}
                            </Button>}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {props?.modalTitle}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={props.handleModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    {!props.hasSpecificParent && <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                        {props.children}
                    </Box>}
                    {props.hasSpecificParent && props.children}
                    {!props.disableSubmitBtn && <Button
                        className='green-btn' onClick={props.modalSubmitBtn} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>{props?.modalTitleSubmitBtn}</Button>}
                </Box>
            </Dialog>
        </>
    );
}

export default ModalComponent;